import React from 'react';
import { FEATURE_FLAG__BEGIN_15 } from '../../../constants/featureflags';
import { CTA_LABEL_FOR_DIFFERENT_TRIAL_LENGTHS } from '../../../experiments/constants';
import { useExperimentContext } from '../../../experiments/context';
import { useCodeSparkFlag } from '../../../featureFlags';
import ActivateCodingSkills from '../sections/ActivateCodingSkills';
import BeginPromotional from '../sections/BeginPromotional';
import CodingSteps from '../sections/CodingSteps';
import Hero from '../sections/Hero';
import KidsBecomeCreators from '../sections/KidsBecomeCreators';
import PlanSelector from '../sections/PaymentModule';

function HomeRedesign({ onCtaClick, planLabels }) {
  const {
    experiments: { differentPlanTrials },
  } = useExperimentContext();
  const begin15Enabled = useCodeSparkFlag(FEATURE_FLAG__BEGIN_15);
  const ctaLabel = differentPlanTrials
    ? CTA_LABEL_FOR_DIFFERENT_TRIAL_LENGTHS
    : planLabels.startYourFreeTrialLabel;

  return (
    <div id="homepage">
      <Hero onCtaClick={onCtaClick} />
      <ActivateCodingSkills ctaLabel={ctaLabel} onCtaClick={onCtaClick} />
      {begin15Enabled && <BeginPromotional onCtaClick={onCtaClick} ctaLabel={ctaLabel} />}
      <CodingSteps ctaLabel={ctaLabel} onCtaClick={onCtaClick} />
      <PlanSelector onCtaClick={onCtaClick} ctaLabel={ctaLabel} />
      <KidsBecomeCreators />
    </div>
  );
}

export default HomeRedesign;



// WEBPACK FOOTER //
// ./src/containers/Home/variants/Redesign.js